module.exports = __webpack_public_path__ + "img/code_ls.6de336f9.png";